import { render, staticRenderFns } from "./App_VuePages.vue?vue&type=template&id=3a7e9ca2&"
import script from "./App_VuePages.vue?vue&type=script&lang=js&"
export * from "./App_VuePages.vue?vue&type=script&lang=js&"
import style0 from "./App_VuePages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a7e9ca2')) {
      api.createRecord('3a7e9ca2', component.options)
    } else {
      api.reload('3a7e9ca2', component.options)
    }
    module.hot.accept("./App_VuePages.vue?vue&type=template&id=3a7e9ca2&", function () {
      api.rerender('3a7e9ca2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/App_VuePages.vue"
export default component.exports